import {action, query, reload} from "@solidjs/router";
import {CreateBooking, UpdateBooking} from "@gs-yoga/sdk/types";
import sdk from "~/sdk/sdk";
import {ApiError} from "~/sdk/error";
import {SearchParamsOption} from "ky";

export const getBookings = query(async (params: SearchParamsOption) => {
    try {
        return await sdk().bookings.list(params).json()
    } catch (e) {
        throw new ApiError("Failed to get bookings", e)
    }
}, "getBookings")

export const getBooking = query(async (id: string) => {
    try {
        return await sdk().bookings.get(id).json()
    } catch (e) {
        throw new ApiError("Failed to get booking", e)
    }
}, "getBooking")

export const createBooking = action(async (req: CreateBooking) => {
    try {
        return await sdk().bookings.create(req).json()
    } catch (e) {
        throw new ApiError("Failed to create booking", e)
    }
})

export const updateBooking = action(async (id: string, req: UpdateBooking) => {
    try {
        await sdk().bookings.update(id, req).json()
        return reload({revalidate: [getBooking.key, getBookings.key]})
    } catch (e) {
        throw new ApiError("Failed to update booking", e)
    }
})
